import React from 'react'
import Card from '@mui/joy/Card';
import Skeleton from '@mui/material/Skeleton';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import './skeleton.scss';

export const IssueStatusCardSkeleton = ({ isStatus = false }) => {
    return (
        <Card variant="outlined" sx={{ gap: 2 }} className={`d-flex flex-${isStatus ? 'row' : "column"} justify-content-${isStatus ? 'start' : "between"} align-items-${isStatus ? 'center' : "start"} p-2`}>
            {!isStatus ? <Skeleton animation="wave" width={'100%'} /> : <Skeleton animation="wave" variant="circular" width={35} height={32} />}
            <div style={{ width: '100%' }} className={`d-flex flex-${isStatus ? 'column' : "row"} justify-content-${isStatus ? 'start' : "between"} align-items-${isStatus ? 'center' : "end"} `}>
                <Skeleton animation="wave" width={isStatus ? '100%' : '15px'} />
                {isStatus ? <Skeleton animation="wave" width={'100%'} /> : <Skeleton animation="wave" variant="circular" width={25} height={22} />}
            </div>
        </Card>

    )
}

export const NormalSkeleton = ({ width = '100px', variant = '', height = '', extraStyles = "my-1" }) => {
    return <Skeleton animation="wave" width={width} variant={variant} height={height} className={`me-2 ${extraStyles}`} style={{ borderRadius: '4px' }} />
}
export const CircularSkeleton = ({ width = 35, height = 32 }) => {
    return <Skeleton animation="wave" variant="circular" width={width} height={height} className='me-2' />
}

/**
 * Table placeholder shown while rows are being fetched.
 *
 * Renders the real column headers and full-width rows so the layout is already
 * settled when the data lands — the table does not jump. Cell widths vary per
 * column so it reads as content rather than a progress bar, and each row fades
 * in slightly after the one above it.
 *
 * @param {string[]} columns        header labels, in order
 * @param {number}   rows           how many placeholder rows to draw
 * @param {boolean}  showCheckbox   leading checkbox column
 * @param {number[]} avatarColumns  indices drawn as a circle instead of a bar
 */
export const TableSkeleton = ({
    columns = [],
    rows = 6,
    showCheckbox = false,
    avatarColumns = [],
}) => {
    // Repeating widths, so every row is not identical.
    const widths = ['70%', '45%', '55%', '60%', '50%', '65%', '40%'];

    return (
        <TableContainer>
            <Table aria-label="Loading" aria-busy="true">
                <TableHead>
                    <TableRow>
                        {showCheckbox ? <TableCell padding="checkbox" /> : null}
                        {columns.map((label, i) => (
                            <TableCell key={`${label}-${i}`} align="left">{label}</TableCell>
                        ))}
                    </TableRow>
                </TableHead>
                <TableBody>
                    {Array.from({ length: rows }).map((_, rowIndex) => (
                        <TableRow
                            key={rowIndex}
                            className="sk-row"
                            style={{ '--sk-delay': `${rowIndex * 70}ms` }}
                        >
                            {showCheckbox ? (
                                <TableCell padding="checkbox" className="ps-4">
                                    <Skeleton animation="wave" variant="rounded" width={18} height={18} />
                                </TableCell>
                            ) : null}

                            {columns.map((label, colIndex) =>
                                avatarColumns.includes(colIndex) ? (
                                    <TableCell key={`${label}-${colIndex}`}>
                                        <Skeleton animation="wave" variant="circular" width={30} height={30} />
                                    </TableCell>
                                ) : (
                                    <TableCell key={`${label}-${colIndex}`}>
                                        <Skeleton
                                            animation="wave"
                                            height={14}
                                            width={widths[(rowIndex + colIndex) % widths.length]}
                                            style={{ borderRadius: '6px' }}
                                        />
                                    </TableCell>
                                )
                            )}
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
};
